var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ranking-entry',{attrs:{"streamer":_vm.result.Streamer,"currentStatus":_vm.currentStatus,"rank":_vm.rank,"score":_vm.result.score,"isPrizeTarget":_vm.isPrizeTarget(),"showScore":_vm.event.showScore,"broadcastSec":_vm.event.showBroadcastTime ? _vm.result.broadcastSec : null}})
}
var staticRenderFns = []

export { render, staticRenderFns }